import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import { rhythm } from "../utils/typography"

var breadcrumbObj = {
  Home: { name: "🏡 Home", slug: "/" },
  Categories: { name: "📚 Categories", slug: "/categories" },
  Git: { name: "📔 Git", slug: "/categories/git" },
  React: { name: "📔 React", slug: "/categories/react" },
  Node: { name: "📔 Node", slug: "/categories/node" },
  Microservices: {
    name: "📔 Microservices",
    slug: "/categories/microservices",
  },
  Gatsby: { name: "📔 Gatsby", slug: "/categories/gatsby" },
  Cpp: { name: "📔 Gatsby", slug: "/categories/cpp" },
  Javascript: { name: "📔 Javascript", slug: "/categories/javascript/" },
  Web: { name: "📔 Web", slug: "/categories/web" },
  Chai_Time: { name: "📔 Chai_Time", slug: "/categories/chai-time" },
  Others: { name: "📔 Others", slug: "/categories/others" },
  Graphql: { name: "📔 GraphQL", slug: "/categories/graphql" },
}

const Crumb = styled.div`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  span {
    font-weight: bold;
    transform: scale(1.2);
    margin: 0 ${rhythm(0.25)};
  }
  a {
    color: var(--color-gray1);
    :hover {
      color: var(--color-secondary);
    }
  }
`

const BreadCrumb = ({ list }) => {
  return (
    <div>
      {list.map((elem, i) => {
        return (
          <Crumb key={elem}>
            <Link to={breadcrumbObj[elem].slug}>
              {breadcrumbObj[elem].name}
            </Link>
            {i + 1 < list.length ? <span className="noselect">›</span> : null}
          </Crumb>
        )
      })}
    </div>
  )
}

export default BreadCrumb
